<!--
 * @Author: Suroc
 * @Date: 2024-07-05 14:49:39
 * @LastEditTime: 2025-01-17 23:51:28
 * @Description: 公共顶部
-->
<template>
  <div class="header" :class="themeClass">
    <img class="logo" src="@/assets/nong/CCRLOGO.png" alt="Logo" />
    <ul class="nav">
      <li>
        <el-dropdown trigger="click">
          <el-button>{{ newLanguage }}</el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="item in Language" :key="item.language" @click="changeLanguage(item)">
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li class="connect dropdownSpan" v-if="walletStore.account">
        <span @click="walletModal.open({ view: 'Account' })">
          {{ $Tool.maskAccount(walletStore.account) }}</span>
      </li>

      <li class="connect" v-else>
        <el-button @click="walletModal.open()">{{ $t('Header.Connect') }}</el-button>
      </li>

    </ul>
  </div>
</template>

<script setup>
import {
  _getAddress,
  connectMetamask,
  _getProvider,
} from '@/utils/web3/ethereum.ts'
import { ElMessage } from "element-plus"
import { useRoute } from 'vue-router'
import { loginUser } from "@/utils/request/apis.js"
import { userWalletStore } from '@/stores/qmx/user'
import {
  createAppKit,
  useAppKit,
  useAppKitTheme,
  useAppKitEvents,
  useAppKitAccount
} from '@reown/appkit/vue'
import { allChains } from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { reconnect } from '@wagmi/core'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useThemeStore, useI18nStore } from '@/stores/settings'
import { computed } from 'vue'
let walletStore = userWalletStore()
const route = useRoute()
// 点击登录
const walletConnection = async () => {
  let addr = await _getAddress()
  if (!addr) {
    ElMessage.warning('无钱包环境正在尝试链接')
    const t = await connectMetamask()
    addr = await _getAddress()
    const sign = "Login CCR sign address" + addr;
    const provider = _getProvider()
    const signature = await provider.getSigner().signMessage(sign);
    if (signature) {
      userLogin(addr, signature)
    } else {
      ElMessage.warning('连接失败')
    }
  } else {
    const sign = "Login CCR sign address" + addr;
    const provider = _getProvider()
    const signature = await provider.getSigner().signMessage(sign);
    if (signature) {
      userLogin(addr, signature)
    } else {
      ElMessage.warning('签名失败')
    }
  }
}
watchEffect(() => {
  if (route.query && route.query.inviteId) {
    localStorage.setItem("CCR:inviteId", route.query.inviteId)
  }
})
const loginIng = ref(false)
const userLogin = async (address, password) => {
  if (loginIng.value) return
  loginIng.value = true
  let pid = 1
  const inviteId = localStorage.getItem("CCR:inviteId")
  if (inviteId) {
    pid = inviteId
  }
  const res = await loginUser({ account: address, password, pid })
  loginIng.value = false
  if (res.code === 1) {
    ElMessage.success("连接成功")
    walletStore.setCurrentAccout(res.data.userinfo)
    walletStore.setUpUserData(res.data.puserinfo)
  }
}
const userSingin = async (addr) => {
  return;
  const address = walletStore.currentAccount.username
  console.log("sign::::", address, addr)
  if (!addr || (address && addr && addr.toLowerCase() === address.toLowerCase())) return
  const sign = "Login CCR sign address" + addr;
  const provider = _getProvider()
  const signature = await provider.getSigner().signMessage(sign);
  if (signature) {
    userLogin(addr, signature)
  } else {
    ElMessage.warning('签名失败')
  }
}






// 原始代码
let { $Tool } = getCurrentInstance().appContext.config.globalProperties
let themeStore = useThemeStore()
let i18nStore = useI18nStore()
let I18nLocale = computed(() => i18nStore.i18nLocale)
let themeClass = computed(() => themeStore.theme)
let userAccount = computed(() => walletStore.account)
let userAccountList = computed(() => walletStore.accountData)
const { locale } = useI18n()
const router = useRouter()
const projectId = import.meta.env.VITE_PROJECT_ID
if (!projectId) {
  throw new Error('VITE_PROJECT_ID is not set')
}
const metadata = {
  name: 'CCR',
  description: 'CCR Liquid Market',
  url: window.location.origin,
  icons: ['https://avatars.githubusercontent.com/u/179229932']
}
const bscTestnet = {
  id: 'eip155:97',
  chainId: 97,
  name: 'BNB Smart Chain Testnet',
  currency: 'tBNB',
  explorerUrl: 'https://testnet.bscscan.com',
  rpcUrl: 'https://data-seed-prebsc-1-s2.bnbchain.org:8545',
  chainNamespace: 'eip155'
}
allChains.push(bscTestnet)
const networks = allChains.filter((item) => {
  return item.currency === 'BNB' || item.currency === 'tBNB'
})
window.wagmiAdapter = new WagmiAdapter({
  ssr: true,
  projectId,
  networks
})
let newLanguage = ref('English')
window.WalletModal = null
let walletModal = ref(null)
let walletTheme = ref(null)
let walletEvents = ref(null)
let Language = ref([
  // {
  //   language: 'zh',
  //   label: '中文'
  // },
  {
    language: 'en',
    label: 'English'
  },
  {
    language: 'zh',
    label: '中文繁体'
  },

  {
    language: 'ke',
    label: '한국어'
  },
  {
    language: 'jp',
    label: '日本語'
  },
  {
    language: 'ba',
    label: 'Bahasa'
  },
  {
    language: 'ti',
    label: 'Tiếng'
  }
])
watch(
  walletEvents,
  (newVal) => {
    let { address, isConnected } = useAppKitAccount()
    wallReconnect(address, isConnected, newVal.data.event)
  },
  { deep: true }
)
onMounted(async () => {
  initWalletConnect()
  Language.value.map((item) => {
    if (localStorage.getItem('i18nLocale') == item.language) {
      newLanguage.value = item.label
    }
  })
  window.ethereum.on('accountsChanged', (accounts) => {
    if (accounts.length > 0) {
      walletStore.acitveAccount(accounts[0])
      walletStore.setAccount(accounts[0])
      // userSingin(accounts[0])
    } else {
      console.log('No account connected.')
    }
  })
})
onBeforeUnmount(() => { })
let initWalletConnect = async () => {
  window.eventAppKit = await createAppKit({
    adapters: [wagmiAdapter],
    themeMode: themeStore.theme == 'dark' ? 'light' : 'dark', // 主题 dark | light
    networks,
    metadata,
    projectId,
    features: {
      email: false, // 邮箱
      socials: [], // 社交
      analytics: true, // 分析
      swaps: false, // 交换
      onramp: false // onramp
    },
    featuredWalletIds: [
      '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4',
      'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
      '20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66'
    ]
  })
  walletModal.value = await useAppKit()
  window.WalletModal = walletModal.value
  walletTheme.value = await useAppKitTheme()
  walletEvents.value = await useAppKitEvents()
  reconnect(wagmiAdapter.wagmiConfig).then((res) => {
    if (res.length) {
      let accounts = res[0].accounts
      if (!accounts.length) return
      walletStore.acitveAccount(accounts[0])
      walletStore.setAccount(accounts)
      userSingin(accounts[0])
    } else {
      walletStore.clearAccount()
    }
  })
  console.log('初始钱包组件成功')
}
/**
 * @description 重连账户
 * @param {address} 账户
 * @param {isConnected} 是否连接中
 */
const timer = ref(null)
let wallReconnect = (address, isConnected, event) => {
  if (address) {
    reconnect(wagmiAdapter.wagmiConfig).then((res) => {
      if (res.length) {
        let accounts = res[0].accounts
        if (!accounts.length) return
        const filteredAddresses = accounts.filter((active) => active === address)
        walletStore.acitveAccount(filteredAddresses[0] ? filteredAddresses[0] : accounts[0])
        walletStore.setAccount(accounts)
        // 点击链接在这里，但是点击断联也调用
        userSingin(filteredAddresses[0] ? filteredAddresses[0] : accounts[0])
      } else {
        walletStore.clearAccount()
        // 清除账号信息
        walletStore.clearCurrentAccount()
      }
    })
    if (userAccount.value && userAccount.value != address) {
      if (!isConnected) {
        walletStore.clearAccount()
      } else {
        if (Array.isArray(userAccountList.value) && userAccountList.value.length) {
          const filteredAddresses = userAccountList.value.filter((active) => active == address)
          walletStore.acitveAccount(
            filteredAddresses[0] ? filteredAddresses[0] : userAccountList.value[0]
          )
          userSingin(filteredAddresses[0] ? filteredAddresses[0] : accounts[0])
        } else {
          if (!userAccountList.value.length) return
          walletStore.acitveAccount(userAccountList.value)
          userSingin(userAccountList.value)
        }
      }
    }
  } else {
    walletStore.clearAccount()
  }
}
/**
 * @description 多语言切换
 * @param {newLocale} 需要切换的语言
 */
let changeLanguage = (item) => {
  i18nStore.setLocale(item.language)
  locale.value = item.language
  newLanguage.value = item.label
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
